import { useEffect, useState } from "react";
import { useRestApiProvider } from "@jugl-web/rest-api";
import { CountryPickerValue } from "@jugl-web/ui-components/web/CountryPicker/types";
import { getUserISO } from "@jugl-web/ui-components/cross-platform/PhoneInput/utils/getUserISO";
import countries from "countries-phone-masks";

export const useDefaultCountry = () => {
  const { authApi } = useRestApiProvider();
  const { data: countryCode } = authApi.useRequestCountryQuery();
  const [defaultCountry, setDefaultCountry] = useState<CountryPickerValue>();

  useEffect(() => {
    if (defaultCountry) return;

    const iso =
      countryCode?.country && countryCode.country !== "default"
        ? countryCode.country
        : getUserISO();

    const found = countries.find((c: CountryPickerValue) => c.iso === iso);
    if (found) {
      setDefaultCountry(found);
    }
  }, [countryCode, defaultCountry]);

  return defaultCountry;
};
